import { Lightbulb } from 'lucide-react';
import {
  VELD_DEFINITIES,
  VOORBEELD_MELDING,
  type MeldingSoort,
  type MeldingVelden as Velden,
} from '../lib/meldingFormulier';

const INVOER_KLASSE =
  'mt-1 w-full px-3 py-2 text-sm bg-surface border border-theme-border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand/40 resize-y font-normal';

/**
 * De verplichte structuur van het meldformulier: per soort de vaste vragen
 * (probleem: deed/verwachtte/gebeurde; wens: doel/waar) met een voorbeeld
 * van een goede melding als hint.
 */
export default function MeldingVelden({
  soort,
  velden,
  onChange,
  autoFocus = true,
}: {
  soort: MeldingSoort;
  velden: Velden;
  onChange: (velden: Velden) => void;
  autoFocus?: boolean;
}) {
  return (
    <div className="space-y-2.5">
      <p className="flex items-start gap-1.5 rounded-lg bg-surface-secondary/60 px-2.5 py-2 text-[11px] text-foreground-secondary">
        <Lightbulb className="h-3.5 w-3.5 mt-px flex-shrink-0 text-warning" />
        <span>{VOORBEELD_MELDING[soort]}</span>
      </p>
      {VELD_DEFINITIES[soort].map((d, i) => (
        <label key={d.sleutel} className="block text-xs font-medium text-foreground-secondary">
          {d.label}
          <textarea
            value={velden[d.sleutel]}
            onChange={(e) => onChange({ ...velden, [d.sleutel]: e.target.value })}
            placeholder={d.placeholder}
            rows={d.rijen}
            autoFocus={autoFocus && i === 0}
            className={INVOER_KLASSE}
          />
        </label>
      ))}
    </div>
  );
}
